import { resetDemoCentering } from './scroll-geometry'
import { waitForDemoReading } from './player-clock'
import { animateDemoContentScroll, scrollToDemoPlayerElement, wait } from './helpers'

export const playDemoSummary = async ({
  content,
  isCancelled,
}: DemoSummaryPlaybackParams): Promise<boolean> => {
  resetDemoCentering(content)
  let summary: HTMLElement | null = null

  for (let attempt = 0; attempt < 100 && !isCancelled(); attempt += 1) {
    summary = content.querySelector<HTMLElement>('.summary-calculator')

    if (summary && summary.getBoundingClientRect().height > 0) {
      break
    }

    await wait(100)
  }

  if (!summary || summary.getBoundingClientRect().height === 0 || isCancelled()) {
    return false
  }

  const heading = summary.querySelector<HTMLElement>('h5') || summary

  if (!await scrollToDemoPlayerElement({ element: heading, isCancelled })) {
    return false
  }

  await wait(1500)

  const distance = content.scrollHeight - content.clientHeight - content.scrollTop
  const duration = Math.max(1000, distance / .35)

  if (!await animateDemoContentScroll({
    content,
    getDestination: () => content.scrollHeight - content.clientHeight,
    duration,
    isCancelled,
  })) {
    return false
  }

  await waitForDemoReading(5000)

  return !isCancelled()
}
